import { ITagLeafSeparator } from '../../../utils/apollo/graphqlSchema';
import { freeze } from '@reduxjs/toolkit';
import { ICreatableEntity, ICreatableNode } from './types';

export const SEPARATOR_NODE: ITagLeafSeparator = freeze({
  __typename: 'TagLeafSeparator',
  dummy: null,
});

export const CREATABLE_NODE: ICreatableNode = freeze({
  __typename: '__CreatableNode',
});

export const CREATABLE_ENTITY: ICreatableEntity = freeze({
  __typename: '__CreatableEntity',
});
